import styled from 'styled-components'
import { sureco } from '../shared/finance.styles'

export const UploadCard = styled.div`
  background: #fff;
  border: 1px solid ${sureco.border};
  border-radius: 12px;
  overflow: hidden;
`

export const UploadCardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 24px;
  border-bottom: 1px solid ${sureco.offWhite};
`

export const UploadCardToggle = styled.span<{ $expanded: boolean }>`
  display: flex;
  align-items: center;
  margin-left: auto;
  color: ${sureco.fg3};
  font-size: 13px;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition:
    transform 0.2s ease,
    background 0.15s;
  transform: rotate(${({ $expanded }) => ($expanded ? '0deg' : '-90deg')});

  &:hover {
    background: ${sureco.offWhite};
    color: ${sureco.fg2};
  }
`

export const UploadCardBody = styled.div<{ $expanded: boolean }>`
  display: ${({ $expanded }) => ($expanded ? 'flex' : 'none')};
  flex-direction: column;
  gap: 16px;
  padding: 0 24px 24px;
`

export const DropZone = styled.div<{ $isDragOver?: boolean }>`
  border: 2px dashed
    ${({ $isDragOver }) => ($isDragOver ? sureco.teal : sureco.borderStrong)};
  border-radius: 12px;
  padding: 48px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  cursor: pointer;
  background: ${({ $isDragOver }) => ($isDragOver ? '#E6F6F7' : sureco.pageBg)};
  transition:
    border-color 0.2s,
    background 0.2s;

  &:hover {
    border-color: ${sureco.teal};
    background: #e6f6f7;
  }
`

export const DropZoneIcon = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 12px;
  background: ${sureco.offWhite};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: ${sureco.placeholder};
`

export const DropZoneText = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${sureco.fg1};
`

export const DropZoneHint = styled.div`
  font-size: 12px;
  color: ${sureco.placeholder};
`

export const PeriodPickerRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`

export const PeriodLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${sureco.fg2};
`

export const FileListHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  color: ${sureco.fg2};
`

export const ClearAllButton = styled.button`
  background: none;
  border: none;
  font-size: 12px;
  color: ${sureco.fg3};
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 4px;
  transition:
    color 0.15s,
    background 0.15s;

  &:hover {
    color: #dc2626;
    background: #fef2f2;
  }
`

export const FileList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 200px;
  overflow-y: auto;
`

export const FileItem = styled.div`
  display: grid;
  grid-template-columns: 1fr 80px 110px;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background: ${sureco.pageBg};
  border-radius: 8px;
  border: 1px solid ${sureco.border};
  font-size: 12px;
  color: ${sureco.fg2};
`

export const FileItemName = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const FileItemSize = styled.span`
  font-size: 11px;
  color: ${sureco.placeholder};
  text-align: right;
`

export const FileItemStatus = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: ${sureco.fg3};
  justify-content: flex-end;
`

export const FileItemError = styled.span`
  grid-column: 1 / -1;
  font-size: 11px;
  color: #dc2626;
  padding-top: 2px;
`

export const RemoveFileButton = styled.button`
  background: none;
  border: none;
  color: ${sureco.placeholder};
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  font-size: 14px;
  transition: color 0.15s;

  &:hover {
    color: #ef4444;
  }
`
